import { render } from "./systemMenu.vue?vue&type=template&id=f40fef80&scoped=true"
import script from "./systemMenu.vue?vue&type=script&lang=js"
export * from "./systemMenu.vue?vue&type=script&lang=js"

import "./systemMenu.vue?vue&type=style&index=0&id=f40fef80&lang=less&scoped=true"
import "./systemMenu.vue?vue&type=style&index=1&id=f40fef80&lang=less"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f40fef80"]])

export default __exports__